




























import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {Grid} from "@/models/Grid";
import {NoCache} from "@/shared/decorator";

import CellButton from "@/components/CellButton.vue";

@Component({
	components: {
		CellButton
	}
})
export default class GridComponent extends Vue {
	
	@Prop({type: Grid, required: true})
	private grid!: Grid;
	
	private SIZE: number = Grid.SIZE;
	
	private resizeEvent: any;
	
	public get offsetX(): number {
		return (-this.grid.minX + 1) * Grid.SIZE;
	}
	
	public get offsetY(): number {
		return (-this.grid.minY + 1) * Grid.SIZE;
	}
	
	public get width(): number {
		return (-this.grid.minX + this.grid.maxX + 2) * Grid.SIZE + 1;
	}
	
	public get height(): number {
		return (-this.grid.minY + this.grid.maxY + 2) * Grid.SIZE + 1;
		
	}
	
	@NoCache
	public get scale(): number {
		if (!this.$el) {
			return 1;
		}
		const gSize = Math.max(this.width, this.height);
		const cSize = Math.min(this.$el.parentElement.clientWidth, this.$el.parentElement.clientHeight);
		
		return cSize / gSize;
	}
	
	public mounted() {
		console.log('AAA', this.grid);
		this.$forceUpdate();
		this.resizeEvent = () => this.$forceUpdate();
		window.addEventListener('resize', this.resizeEvent);
	}
	
	
	public beforeDestroy() {
		window.removeEventListener('resize', this.resizeEvent);
	}
	
	@Emit()
	public onBeforeConfirm(): void {
	}
	
	@Emit()
	public async onConfirm(): Promise<void> {
	}
	
}
